var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _path9, _path0, _path1, _path10, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 203,
    viewBox: "0 0 276 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.429 63H137.571L144 138H117L123.429 63Z",
    fill: "#EFEFFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.429 63H137.572L138.5 74H122.5L123.429 63Z",
    fill: "#CCE5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.429 63H177.571L184 138H157L163.429 63Z",
    fill: "#EFEFFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.429 63H216.571L223 138H196L202.429 63Z",
    fill: "#EFEFFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202.429 63H216.572L217.5 74H201.5L202.429 63Z",
    fill: "#CCE5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.429 63H177.572L178.5 74H162.5L163.429 63Z",
    fill: "#CCE5FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0791 163.185C5.0791 160.976 6.86996 159.185 9.0791 159.185H86.9204C89.1295 159.185 90.9204 160.976 90.9204 163.185V195.926C90.9204 198.135 89.1295 199.926 86.9204 199.926H9.0791C6.86996 199.926 5.0791 198.135 5.0791 195.926V163.185Z",
    fill: "#28345A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 158C0 155.791 1.79086 154 4 154H92C94.2091 154 96 155.791 96 158V159.63C96 161.839 94.2091 163.63 92 163.63H4C1.79086 163.63 0 161.839 0 159.63V158Z",
    fill: "#CCE5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 173,
    width: 7,
    height: 15,
    rx: 3.5,
    fill: "#EFEFFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 173,
    width: 7,
    height: 15,
    rx: 3.5,
    fill: "#EFEFFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1429 20H90.8571L103 200H52L64.1429 20Z",
    fill: "#EFEFFD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M97 149C97 146.791 98.7909 145 101 145H262C264.209 145 266 146.791 266 149V196C266 198.209 264.209 200 262 200H101C98.7909 200 97 198.209 97 196V149Z",
    fill: "#28345A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M87 142C87 139.791 88.7909 138 91 138H272C274.209 138 276 139.791 276 142V147C276 149.209 274.209 151 272 151H91C88.7909 151 87 149.209 87 147V142Z",
    fill: "#CCE5FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 200C0 198.343 1.34315 197 3 197H273C274.657 197 276 198.343 276 200V200C276 201.657 274.657 203 273 203H3C1.34315 203 0 201.657 0 200V200Z",
    fill: "#CCE5FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 163,
    width: 7,
    height: 15,
    rx: 3.5,
    fill: "#EFEFFD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 163,
    width: 7,
    height: 15,
    rx: 3.5,
    fill: "#EFEFFD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 163,
    width: 7,
    height: 15,
    rx: 3.5,
    fill: "#EFEFFD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 163,
    width: 7,
    height: 15,
    rx: 3.5,
    fill: "#EFEFFD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 163,
    width: 7,
    height: 15,
    rx: 3.5,
    fill: "#EFEFFD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 163,
    width: 7,
    height: 15,
    rx: 3.5,
    fill: "#EFEFFD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 163,
    width: 7,
    height: 15,
    rx: 3.5,
    fill: "#EFEFFD"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 163,
    width: 7,
    height: 15,
    rx: 3.5,
    fill: "#EFEFFD"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 163,
    width: 7,
    height: 15,
    rx: 3.5,
    fill: "#EFEFFD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1484 20H90.8177L91.5938 31H63.4092L64.1484 20Z",
    fill: "#CCE5FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8333 17C67.275 17 66 15.725 66 14.1667C66 6.34667 72.3467 0 80.1667 0H94.3333C95.8917 0 97.1667 1.275 97.1667 2.83333C97.1667 4.39167 95.8917 5.66667 94.3333 5.66667H80.1667C75.4917 5.66667 71.6667 9.49167 71.6667 14.1667C71.6667 15.725 70.3917 17 68.8333 17Z",
    fill: "#E6E7E8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6663 17H80.1663C78.608 17 77.333 15.725 77.333 14.1667C77.333 12.6083 78.608 11.3333 80.1663 11.3333H88.6663C90.2247 11.3333 91.4997 12.6083 91.4997 14.1667C91.4997 15.725 90.2247 17 88.6663 17Z",
    fill: "#E6E7E8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M111.334 17H100C98.442 17 97.167 15.725 97.167 14.1667C97.167 12.6083 98.442 11.3333 100 11.3333H111.334C112.892 11.3333 114.167 12.6083 114.167 14.1667C114.167 15.725 112.892 17 111.334 17Z",
    fill: "#E6E7E8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.333 5.66667H105.666C104.108 5.66667 102.833 4.39167 102.833 2.83333C102.833 1.275 104.108 0 105.666 0H111.333C112.891 0 114.166 1.275 114.166 2.83333C114.166 4.39167 112.891 5.66667 111.333 5.66667Z",
    fill: "#E6E7E8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.833 57C126.275 57 125 55.725 125 54.1667C125 46.3467 131.347 40 139.167 40H153.333C154.892 40 156.167 41.275 156.167 42.8333C156.167 44.3917 154.892 45.6667 153.333 45.6667H139.167C134.492 45.6667 130.667 49.4917 130.667 54.1667C130.667 55.725 129.392 57 127.833 57Z",
    fill: "#E6E7E8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M147.666 57H139.166C137.608 57 136.333 55.725 136.333 54.1667C136.333 52.6083 137.608 51.3333 139.166 51.3333H147.666C149.225 51.3333 150.5 52.6083 150.5 54.1667C150.5 55.725 149.225 57 147.666 57Z",
    fill: "#E6E7E8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M170.334 57H159C157.442 57 156.167 55.725 156.167 54.1667C156.167 52.6083 157.442 51.3333 159 51.3333H170.334C171.892 51.3333 173.167 52.6083 173.167 54.1667C173.167 55.725 171.892 57 170.334 57Z",
    fill: "#E6E7E8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M170.333 45.6667H164.666C163.108 45.6667 161.833 44.3917 161.833 42.8333C161.833 41.275 163.108 40 164.666 40H170.333C171.891 40 173.166 41.275 173.166 42.8333C173.166 44.3917 171.891 45.6667 170.333 45.6667Z",
    fill: "#E6E7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/site.76dd4f6c144608a75feb10402f235fed.svg";
export { ForwardRef as ReactComponent };